<script setup lang="ts">
type ParagraphSize = 'sm' | 'md' | 'custom';
const { tag = 'p', size = 'md' } = defineProps<{
  tag?: string;
  size?: ParagraphSize;
}>();
defineSlots<{ default: () => void }>();
</script>

<template>
  <AppText
    :as="tag"
    :size
    class="leading-5 font-normal tracking-wide lg:leading-6"
  >
    <slot />
  </AppText>
</template>
